import React from "react";

export default function EventTypeTabs({ activeTab, onTabChange, counts = {} }) {
  const safeCounts = {
    all: 0,
    past: 0,
    current: 0,
    upcoming: 0,
    loading: false,
    ...counts,
  };

  const tabs = [
    { id: "all", label: "All Events", variant: "all" },
    { id: "upcoming", label: "Upcoming", variant: "upcoming" },
    { id: "current", label: "Current", variant: "current" },
    { id: "past", label: "Past", variant: "past" },
  ];

  return (
    <div className="card border-0 mb-3">
      <div className="card-body">
        <div className="row">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <div key={tab.id} className="col-md-3 col-sm-6 col-6">
                <div
                  className={`card border-0 cursor-pointer transition-all event-tab-card event-tab-card--${tab.variant} ${
                    isActive ? "event-tab-card--active shadow-sm" : "bg-light hover-shadow"
                  }`}
                  onClick={() => onTabChange(tab.id)}
                  style={{
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    minHeight: "80px",
                  }}
                >
                  <div className="card-body text-center py-3">
                    <div
                      className={`fw-bold mb-1 event-tab-label ${
                        isActive && tab.variant !== "current" && tab.variant !== "past"
                          ? "text-white"
                          : ""
                      }`}
                    >
                      {tab.label}
                    </div>
                    <div
                      className={`h4 mb-0 ${
                        isActive && (tab.variant === "all" || tab.variant === "upcoming")
                          ? "text-white"
                          : isActive
                            ? ""
                            : "text-dark"
                      }`}
                    >
                      {safeCounts.loading ? (
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        tab.id === "all"
                          ? safeCounts.all
                          : tab.id === "past"
                            ? safeCounts.past
                            : tab.id === "current"
                              ? safeCounts.current
                              : safeCounts.upcoming
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
